import React from 'react';
import { Helmet } from 'react-helmet';

interface SEOProps {
  title: string;
  description: string;
  image?: string;
  url?: string;
  type?: string;
  keywords?: string[];
}

export const SEO: React.FC<SEOProps> = ({
  title,
  description,
  image = '/og-image.jpg',
  url = 'https://alio.com',
  type = 'website',
  keywords = [],
}) => {
  const siteTitle = 'Alio';
  const fullTitle = `${title} | ${siteTitle}`;
  const fullUrl = url.startsWith('http') ? url : `https://alio.com${url}`;
  const fullImage = image.startsWith('http') ? image : `https://alio.com${image}`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords.length > 0 && (
        <meta name="keywords" content={keywords.join(', ')} />
      )}
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta charSet="utf-8" />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImage} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImage} />

      {/* Additional Meta Tags */}
      <meta name="theme-color" content="#ffffff" />
      <link rel="canonical" href={fullUrl} />
    </Helmet>
  );
}; 